export const ComponentsHelpPage =
  'https://support.koppla.de/de/articles/92555-wie-erstelle-ich-meine-struktur-in-koppla';
export const ComponentsLoomLink =
  'https://www.loom.com/embed/b872fabe1ed442a6a7c8acb71d05bcf0?sid=cded1364-2aef-4d28-97c2-57f97f9d6183&hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true';
export const SECTION_TOOLBAR_DELAY = 500;
